var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transition}},[(_vm.show)?_c('div',{staticClass:"modal c-modal",on:{"click":e => _vm.close(e)}},[_c('div',{class:['modal__container', _vm.size]},[_c('div',{class:_vm.wrapperClass},[_vm._t("default",function(){return [_vm._v("Modal Content")]})],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }